The details of the `CandidateProcessHistoryItem` that was deleted.
